import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const UserSearchItem = ({ user, onSendRequest, loading, onPress }) => {
  const getButtonContent = () => {
    switch (user.relationshipStatus) {
      case 'friends':
        return {
          text: 'Friends',
          icon: 'checkmark-circle',
          color: '#5E3D2D',
          disabled: true,
        };
      case 'requestSent':
        return {
          text: 'Pending',
          icon: 'time',
          color: '#9C6B42',
          disabled: true,
        };
      default:
        return {
          text: 'Add Friend',
          icon: 'person-add',
          color: '#F9F5F3',
          disabled: false,
        };
    }
  };

  const buttonContent = getButtonContent();

  return (
    <View style={styles.container}>
      <TouchableOpacity 
        style={styles.userInfo}
        onPress={() => onPress && onPress(user)}
        activeOpacity={0.7}
      >
        <View style={styles.avatarContainer}>
          {user.pfpUrl ? (
            <Image source={{ uri: user.pfpUrl }} style={styles.avatar} />
          ) : (
            <View style={styles.defaultAvatar}>
              <Ionicons name="person" size={24} color="#666" />
            </View>
          )}
        </View>
        <View style={styles.textContainer}>
          <Text style={styles.name}>{user.name || 'Unknown User'}</Text>
          <Text style={styles.username}>@{user.username || 'unknown'}</Text>
        </View>
      </TouchableOpacity>
      
      <TouchableOpacity
        style={[
          styles.button,
          { backgroundColor: buttonContent.color },
          buttonContent.disabled && styles.disabledButton
        ]}
        onPress={() => onSendRequest(user.username || user.name)}
        disabled={loading || buttonContent.disabled}
      >
        <Ionicons 
          name={buttonContent.icon} 
          size={16} 
          color={buttonContent.color === '#F9F5F3' ? '#4e2916' : 'white'} 
        />
        <Text style={[
          styles.buttonText,
          { color: buttonContent.color === '#F9F5F3' ? '#4e2916' : 'white' }
        ]}>
          {buttonContent.text}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    backgroundColor: 'white',
    borderRadius: 12,
    marginBottom: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  avatarContainer: {
    marginRight: 12,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
  },
  defaultAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#f0f0f0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    flex: 1,
  },
  name: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 2,
  },
  username: {
    fontSize: 14,
    color: '#666',
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    gap: 4,
  },
  disabledButton: {
    opacity: 0.6,
  },
  buttonText: {
    color: '#000000',
    fontSize: 14,
    fontWeight: '500',
  },
});

export default UserSearchItem; 